import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Activity, Brain, UtensilsCrossed } from 'lucide-react';
const symptoms = [{
  title: 'Vientre Hinchado',
  description: 'Despiertas plano y terminas el día sintiéndote como un globo.',
  icon: Activity
}, {
  title: 'Fatiga Mental',
  description: 'Niebla mental y bajones de energía inexplicables a media tarde.',
  icon: Brain
}, {
  title: 'Digestiones Pesadas',
  description: "Incomodidad constante sin importar lo 'limpio' que comas.",
  icon: UtensilsCrossed
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function SymptomMatrix() {
  return <section className="py-32 md:py-44 bg-sage" data-id="element-170">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <span className="text-forest/60 font-semibold tracking-wider text-sm uppercase mb-3 block" data-id="element-173">
            El Problema
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest" data-id="element-174">
            ¿Te reconoces en esto?
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-175">
          {symptoms.map((symptom, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-sage-dark/30" data-id="element-176">
              <div className="w-12 h-12 bg-sage rounded-xl flex items-center justify-center mb-6" data-id="element-177">
                <symptom.icon className="w-6 h-6 text-forest" strokeWidth={1.5} data-id="element-178" />
              </div>
              <h3 className="text-xl font-bold text-forest mb-3" data-id="element-179">
                {symptom.title}
              </h3>
              <p className="text-forest/70 leading-relaxed" data-id="element-180">
                {symptom.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}